// src/pages/PermissionsPage.jsx
import React from "react";
import CreatePermissionForm from "../components/CreatePermissionForm";

const PermissionsPage = () => {
  return (
      <div style={{ padding: 2 ,fontSize: "12px" }}>
      <h2>Manage Permissions</h2>
      <CreatePermissionForm />
      {/* Add permission list + edit functionality here if needed */}
    </div>
  );
};

export default PermissionsPage;
